
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/bringing-consistency-to-material-ui-customization-apis",
      function () {
        return require("private-next-pages/blog/bringing-consistency-to-material-ui-customization-apis.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/bringing-consistency-to-material-ui-customization-apis"])
      });
    }
  